(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('Media', Media);

    Media.$inject = ['$resource', app.modules.common.constants.appsettings];
    function Media($resource, ggSettings) {
        var actions,
            resource,
            url = ggSettings.grpapi.root + "media(type=':type',id=:id)/$value";

        // Define Actions
        actions = angular.copy($resource.defaults.actions);
        angular.forEach(actions, addRequestInterceptor);
        angular.extend(actions.get, { responseType: 'arraybuffer', transformResponse: transformResponse });

        // Create Resource
        resource = $resource(url, { type: '@type', id: '@id' }, actions);
        delete resource.query;

        // Return
        return resource;

        function addRequestInterceptor(action) {
            action.interceptor = { request: transformRequest };
        }

        function transformRequest(config) {
            var data = config.data,
                params = config.params,
                overriddenUrl = (params && params.url) || (data && data.url);

            if (data) {
                config.data = data.buffer;
                config.headers['Content-Type'] = data.contentType || data.buffer.type;
                if (data.progressKey) 
                    config.headers['X-ProgressKey'] = data.progressKey;
                
                config.transformRequest = [];
            }

            if (overriddenUrl)
                config.url = overriddenUrl;

            return config;
        }

        function transformResponse(response, headersGetter, status) {
            return status === 200 ? { buffer: response, contentType: headersGetter('Content-Type') } : response;
        }
    }
})();